import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

import connectionHQ from "@/pages/connectionHQ.vue";
import index from "@/pages/index.vue";
import home from "@/pages/home.vue";
import applicantList from "@/pages/applicantList.vue";
import enrolmentClosed from "@/pages/enrolmentClosed.vue";
import currentSituationBoard from "@/pages/currentSituationBoard.vue";
import cancelerList from "@/pages/cancelerList.vue";
import courseHistory from "@/pages/courseHistory.vue";
import noticeManagement from "@/pages/noticeManagement.vue";
import noticeCreate from "@/pages/noticeCreate.vue";
import siteMetaConfig from "@/pages/siteMetaConfig.vue";
import enrolmentStep1 from "@/pages/enrolmentStep1.vue";
import enrolmentStep2 from "@/pages/enrolmentStep2.vue";
import enrolmentStep3_1 from "@/pages/enrolmentStep3_1.vue";
import enrolmentStep3_2 from "@/pages/enrolmentStep3_2.vue";
import busanSubmission from "@/pages/busanSubmission.vue";
import questionPage from "@/pages/questionPage.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    // { path: "/", redirect: "/home" },
    {
      path: "/",
      component: index,
    },
    {
      path: "/connectionHQ",
      component: connectionHQ,
    },
    {
      // 메인
      path: "/home",
      name: "home",
      component: home,
    },
    {
      // 신청자 리스트
      path: "/applicantList",
      name: "applicantList",
      component: applicantList,
    },
    {
      // 현황 Board
      path: "/currentSituationBoard",
      name: "currentSituationBoard",
      component: currentSituationBoard,
    },
    {
      // 신청 마감 페이지
      path: "/enrolmentClosed",
      name: "enrolmentClosed",
      component: enrolmentClosed,
    },
    {
      // 취소자 리스트
      path: "/cancelerList",
      name: "cancelerList",
      component: cancelerList,
    },
    {
      // 수강내역
      path: "/courseHistory",
      name: "courseHistory",
      component: courseHistory,
    },
    {
      // 공지사항 관리
      path: "/noticeManagement",
      name: "noticeManagement",
      component: noticeManagement,
    },
    {
      // 공지사항 등록, 수정
      path: "/noticeCreate",
      name: "noticeCreate",
      component: noticeCreate,
    },
    {
      // 사이트 SEO/메타 설정
      path: "/siteMetaConfig",
      name: "siteMetaConfig",
      component: siteMetaConfig,
    },
    {
      // 수강신청 등록 (1단계)
      path: "/enrolmentStep1",
      name: "enrolmentStep1",
      component: enrolmentStep1,
    },
    {
      // 수강신청 등록 (2단계)
      path: "/enrolmentStep2",
      name: "enrolmentStep2",
      component: enrolmentStep2,
    },
    {
      // 수강신청 등록 (3단계 - 1:1)
      path: "/enrolmentStep3_1",
      name: "enrolmentStep3_1",
      component: enrolmentStep3_1,
    },
    {
      // 수강신청 등록 (3단계 - 그룹)
      path: "/enrolmentStep3_2",
      name: "enrolmentStep3_2",
      component: enrolmentStep3_2,
    },
    {
      // 부산광역시교육청 과제제출
      path: "/busanSubmission",
      name: "busanSubmission",
      component: busanSubmission,
    },
    {
      // 부산광역시교육청 과제제출
      path: "/questionPage",
      name: "questionPage",
      component: questionPage,
    },
  ],
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

// 외부 공개 페이지 없음. 무조건 connectionHQ로 로그인해서 토큰을 받아야 진입 가능.
// connectionHQ만 예외(토큰을 발급받는 진입점).
router.beforeEach((to, from, next) => {
  const token = store.state.accessToken;
  if (to.path === "/connectionHQ") {
    next();
    return;
  }
  if (!token) {
    // 토큰 없으면 진입 차단 → alert 후 사이트로 내보냄
    alert("접근권한이 없습니다. 로그인 후 이용해주세요.");
    window.location.href = "https://life.carrotglobal.com/";
    return;
  }
  next();
});

export default router;
